import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material';

import { SessionStorageService, ParameterConfigService, PageContentService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';

import { AuthenticationComponent, AlertComponent } from '../common/index';

@Component({
    selector: 'shared-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    
    currentPage: string;
    @Input() pageContent: PageContent;
    @Input() scrollYP: number;

    constructor(
        private router: Router,
        private paramConfigService: ParameterConfigService,
        private pageContentService: PageContentService,
        private storageService: SessionStorageService,
        private dialog: MatDialog
    ) {

        // To Get the Current Route

        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.currentPage = event.urlAfterRedirects;
                }
            });
    }

    ngOnInit() {
    }

    cmdRedirect(strPage: string) {
        this.pageContentService.pageContentYN = true;        

        let link = [strPage];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.pageContentService.pageContentYN = false;
                }
                else {
                    this.pageContentService.pageContentYN = false;

                    if (this.currentPage != "/" + strPage) {
                        this.dialog.closeAll();

                        this.dialog.open(AuthenticationComponent, {
                            disableClose: true,
                            panelClass: "alert-modal",
                            data: { message: strPage === 'services/location' ? 'House_Check' : 'The service is accessible to authenticated users only.', RouterLink: strPage}
                        });
                    }
                }
            });
    }

    enableServiceLink(): boolean {
        return this.paramConfigService.enableLink();
    }

    
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/layout/footer.component.ts